import { render, staticRenderFns } from "./UrgenciasView.vue?vue&type=template&id=38574afb&scoped=true"
import script from "./UrgenciasView.vue?vue&type=script&lang=js"
export * from "./UrgenciasView.vue?vue&type=script&lang=js"
import style0 from "./UrgenciasView.vue?vue&type=style&index=0&id=38574afb&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38574afb",
  null
  
)

export default component.exports